var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 140,
    viewBox: "0 0 165 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EQC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M139.824 90.6C134.704 90.6 130.038 89.5867 125.824 87.56C121.611 85.48 118.251 82.3867 115.744 78.28C113.291 74.1733 112.064 69 112.064 62.76C112.064 58.0133 112.811 53.9067 114.304 50.44C115.851 46.9733 117.931 44.0933 120.544 41.8C123.211 39.5067 126.251 37.8 129.664 36.68C133.078 35.56 136.651 35 140.384 35C143.424 35 146.198 35.3467 148.704 36.04C151.211 36.68 153.664 37.6667 156.064 39L156.384 51.4H150.304L147.984 40.92C146.171 40.0133 144.251 39.56 142.224 39.56C139.398 39.56 136.758 40.36 134.304 41.96C131.904 43.56 129.958 46.0933 128.464 49.56C126.971 52.9733 126.224 57.4 126.224 62.84C126.224 68.28 126.944 72.7067 128.384 76.12C129.824 79.48 131.718 81.96 134.064 83.56C136.464 85.16 139.078 85.96 141.904 85.96C143.024 85.96 144.144 85.8267 145.264 85.56C146.384 85.2933 147.504 84.92 148.624 84.44L150.864 74.2H156.944L156.624 86.52C154.491 87.6933 152.011 88.6533 149.184 89.4C146.411 90.2 143.291 90.6 139.824 90.6Z",
    fill: "url(#paint0_linear_240_2091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.9245 85.96C82.6445 85.96 84.8044 84.9467 86.4044 82.92C88.0578 80.8933 89.2578 78.1467 90.0045 74.68C90.7511 71.16 91.1245 67.1867 91.1245 62.76C91.1245 58.3333 90.7511 54.3867 90.0045 50.92C89.2578 47.4533 88.0578 44.7067 86.4044 42.68C84.8044 40.6533 82.6445 39.64 79.9245 39.64C77.2578 39.64 75.0978 40.6533 73.4445 42.68C71.7911 44.7067 70.5911 47.4533 69.8445 50.92C69.0978 54.3867 68.7245 58.3333 68.7245 62.76C68.7245 67.1867 69.0978 71.16 69.8445 74.68C70.5911 78.1467 71.7911 80.8933 73.4445 82.92C75.0978 84.9467 77.2578 85.96 79.9245 85.96ZM91.2845 105.56C85.7911 105.56 81.4711 104.093 78.3245 101.16C75.1778 98.2267 73.4711 94.44 73.2045 89.8C69.7911 88.8933 66.6711 87.32 63.8445 85.08C61.0178 82.7867 58.7511 79.8 57.0445 76.12C55.3911 72.3867 54.5645 67.9333 54.5645 62.76C54.5645 58.1733 55.2578 54.1467 56.6445 50.68C58.0311 47.2133 59.9245 44.3333 62.3245 42.04C64.7245 39.6933 67.4445 37.9333 70.4845 36.76C73.5245 35.5867 76.6711 35 79.9245 35C83.2311 35 86.3778 35.5867 89.3645 36.76C92.4045 37.88 95.1245 39.5867 97.5245 41.88C99.9245 44.1733 101.818 47.08 103.204 50.6C104.591 54.0667 105.284 58.12 105.284 62.76C105.284 67.9867 104.404 72.4933 102.644 76.28C100.884 80.0133 98.5378 83.0267 95.6045 85.32C92.7245 87.56 89.4978 89.1067 85.9245 89.96C86.0311 92.9467 86.8845 95.2667 88.4845 96.92C90.0844 98.6267 92.1911 99.48 94.8045 99.48C95.6045 99.48 96.5111 99.4 97.5245 99.24C98.5378 99.1333 99.5511 98.8933 100.564 98.52L102.324 103C100.991 103.853 99.3645 104.493 97.4445 104.92C95.5245 105.347 93.4711 105.56 91.2845 105.56Z",
    fill: "url(#paint1_linear_240_2091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 40.84V36.52H48.8L49.36 50.28H42.72L41.12 41H27.76C27.7067 44.04 27.6533 47.1067 27.6 50.2C27.6 53.2934 27.6 56.4134 27.6 59.56H36.24L37.2 53.32H41.84V70.52H37.2L36.24 64.28H27.6C27.6 67.96 27.6 71.4534 27.6 74.76C27.6533 78.0667 27.7067 81.3467 27.76 84.6H42.72L44.32 75.32H50.96L50.4 89.08H8V84.76L14 84.12C14.1067 80.8667 14.16 77.5867 14.16 74.28C14.16 70.9734 14.16 67.64 14.16 64.28V61.32C14.16 58.0134 14.16 54.7067 14.16 51.4C14.16 48.04 14.1067 44.7334 14 41.48L8 40.84Z",
    fill: "url(#paint2_linear_240_2091)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_2091",
    x1: 5.36007,
    y1: 66.08,
    x2: 159.36,
    y2: 66.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7DBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DBB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_2091",
    x1: 5.36008,
    y1: 66.08,
    x2: 159.36,
    y2: 66.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7DBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DBB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_240_2091",
    x1: 5.36,
    y1: 66.08,
    x2: 159.36,
    y2: 66.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7DBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DBB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqc);
export default __webpack_public_path__ + "static/media/eqc.90c0bd4d37779004b030514beb1e0ec4.svg";
export { ForwardRef as ReactComponent };